module.exports = __webpack_public_path__ + "static/media/enchanting-2.b51f1eb1.png";